// export const DEV = 'http://localhost:1337';
export const DEV = 'https://guampowerauthority-api.xtendly.com';
export const PROD = 'https://admin.guampowerauthority.com';
export const API = PROD;
